import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';
import { AircraftCardComponent } from './aircraft-card/aircraft-card.component';
import { RoutingInfoComponent } from './routing-info/routing-info.component';

@NgModule({
  declarations: [AircraftCardComponent, RoutingInfoComponent],
  imports: [CommonModule, SharedModule],
  exports: [AircraftCardComponent],
})
export class AircraftModule {}
